import { fetchOuQuery } from '@/graphql/tree'
import { fetchResearchProjectQuery } from '@/graphql/project'
import { fetchPublicationQuery } from '@/graphql/publication'
import { fetchAwardQuery } from '@/graphql/award'
import { fetchCooperationQuery } from '@/graphql/cooperation'
import { fetchEventQuery } from '@/graphql/event'
import { fetchStaffQuery } from '@/graphql/staff'

import { fetchResearchProjectDetailsQuery } from '@/graphql/projectDetails'
import { fetchPublicationDetailsQuery } from '@/graphql/publicationDetails'
import { fetchAwardDetailsQuery } from '@/graphql/awardDetails'
import { fetchCooperationDetailsQuery } from '@/graphql/cooperationDetails'
import { fetchEventDetailsQuery } from '@/graphql/eventDetails'

import {
  fetchOrganisationalUnits,
  findClosestPublicOU
} from '@/graphql/organisationalUnits'

import { fetchStatsQuery } from '@/graphql/stats'

import { fetchLeurisProfileQuery } from '@/graphql/leurisProfile'

import { fetchOuDetailsQuery } from '@/graphql/ouDetails'

export {
  fetchOuQuery,
  fetchStaffQuery,
  fetchResearchProjectQuery,
  fetchPublicationQuery,
  fetchAwardQuery,
  fetchCooperationQuery,
  fetchEventQuery,
  findClosestPublicOU,
  fetchOrganisationalUnits,
  fetchStatsQuery,
  fetchLeurisProfileQuery,
  fetchOuDetailsQuery
}

export const detailsQuery = {
  forschungsprojekt: fetchResearchProjectDetailsQuery,
  publikation: fetchPublicationDetailsQuery,
  preis: fetchAwardDetailsQuery,
  kooperation: fetchCooperationDetailsQuery,
  veranstaltung: fetchEventDetailsQuery
}



// WEBPACK FOOTER //
// ./src/graphql/index.js